// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wj84jn","logo":"Dv7QGg","active":"_5vZe6P","shadow":"r6n5q_"};